import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { db, persistDb } from '@/test/mocks/db';
import { networkDelay, removeAllMockAuthTokens } from '@/test/mocks/utils';

import { LogoutUserResponse } from '../types';

export const logout = (): Promise<LogoutUserResponse.Root> => {
  return axios.get('/user/v1/logout');
};

export const logoutMockHandler = http.get(
  `${env.API_URL}/user/v1/logout`,
  async (): Promise<HttpResponse<LogoutUserResponse.Root>> => {
    removeAllMockAuthTokens();
    db.user.update({
      where: {
        selected_profile: {
          equals: true,
        },
      },
      data: { selected_profile: false },
    });
    persistDb('user');
    const result: LogoutUserResponse.Root = {
      status: 'Success',
      message: 'Logged out successfully',
    };
    await networkDelay();
    return HttpResponse.json(result);
  }
);
